import OrgOwnedAccountErrorFlag from '../components/profile/settings/flags/OrgOwnedAccountErrorFlag';
import OrgOwnedAccountLinkSuccessFlag from '../components/profile/settings/flags/OrgOwnedAccountLinkSuccesFlag';
import LinkPersonalMakePrimarySuccessFlag from '../components/profile/settings/flags/LinkPersonalMakePrimarySuccessFlag';
import UnlinkAccountSuccessFlag from '../components/profile/settings/flags/UnlinkAccountSuccessFlag';
import { FlagComponent } from '../components/profile/settings/flags/FlagTypes';
import GenericErrorFlag from '../components/profile/settings/flags/GenericErrorFlag';
import GenericAccountLinkError from '../components/profile/settings/flags/GenericAccountLinkError';

// TODO: Update code with real backend code number when implemented
export const ALL_ACCOUNT_FLAGS: Record<string | number, FlagComponent> = {
  generic_error: GenericErrorFlag,
  org_owned: OrgOwnedAccountErrorFlag,
  org_owned_linked: OrgOwnedAccountLinkSuccessFlag,
  unlink_success: UnlinkAccountSuccessFlag,
  make_primary: LinkPersonalMakePrimarySuccessFlag,
  unlink: OrgOwnedAccountErrorFlag,
};
export const ALL_ACCOUNT_FLAGS_ERRORS: Record<string | number, FlagComponent> =
  {
    generic_error: GenericErrorFlag,
    generic_account_link_error: GenericAccountLinkError,
  };
